import React, {useState} from 'react';

const useViewport = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  const [width, setWidth] = useState(window.innerWidth);
  React.useLayoutEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);
  return {width};
};

export default useViewport;
